// Shared loader for cash flow actuals data
// Prefers QB-synced data from localStorage, falls back to static JSON file
import cashFlowDataDefault from '../data/cash_flow_2026.json';

const MONTH_LABELS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function loadCashFlowActuals() {
  try {
    const qbCF = localStorage.getItem('bcc_qb_mapped_cf');
    const qbBS = localStorage.getItem('bcc_qb_mapped_bs');
    const throughMonth = parseInt(localStorage.getItem('bcc_qb_through_month')) || 0;

    if (qbCF && throughMonth > 0) {
      const mappedCF = JSON.parse(qbCF);
      const mappedBS = qbBS ? JSON.parse(qbBS) : null;

      // Build actuals months from QB data
      const months = [];
      for (let i = 0; i < throughMonth; i++) {
        const qbMonth = mappedCF.months[i];
        months.push({
          month: i + 1,
          label: MONTH_LABELS[i],
          operatingCF: qbMonth.operatingCF,
          investingCF: qbMonth.investingCF,
          distributions: qbMonth.distributions,
          otherFinancing: qbMonth.otherFinancing || 0,
          actual: true,
        });
      }

      // Use QB bank balance to back-calculate starting balance
      // ending balance after throughMonth = startingBalance + sum of all net changes
      // So startingBalance = bankBalance - sum of all net changes
      let startingBalance = cashFlowDataDefault.startingBalance;
      if (mappedBS?.totalBankBalance) {
        const totalNetChange = months.reduce((sum, m) =>
          sum + m.operatingCF + m.investingCF + m.distributions + (m.otherFinancing || 0), 0);
        startingBalance = mappedBS.totalBankBalance - totalNetChange;
      }

      return {
        minimumThreshold: cashFlowDataDefault.minimumThreshold,
        startingBalance,
        months,
        source: 'quickbooks',
      };
    }
  } catch (e) { /* fall back to default */ }
  return { ...cashFlowDataDefault, source: 'json' };
}
